export default __webpack_public_path__ + "static/media/portfolio.32da29af.svg";